<script setup>
import { computed } from 'vue';
import ChassisSectionFrameAgreement from './ChassisSectionFrameAgreement';
import ChassisSectionStockVehicle from './ChassisSectionStockVehicle';
import ChassisSectionStandard from './ChassisSectionStandard';
import ChassisSectionStandardBev from './ChassisSectionStandardBev';
import ChassisSectionDW5 from './ChassisSectionDW5';
import ChassisSectionDW5V2 from './ChassisSectionDW5V2';

import { useMainStore } from '@/store/index.js';
const store = useMainStore();

const props = defineProps({
  items: {
    type: Object,
    default: null,
  },
  images: {
    type: Object,
    required: true,
  },
  offerTemplate: {
    type: String,
    default: '',
    required: true,
  },
  specType: {
    type: String,
    default: '',
    required: true,
  },
  isFrameAgreement: {
    type: Boolean,
    default: false,
    required: true,
  },
  chassisDescriptionKey: {
    type: String,
    required: false,
    default: '',
  },
  isBev: {
    type: Boolean,
    default: false,
  },
  isDW5: {
    type: Boolean,
    default: false,
  },
  isDW5V2: {
    type: Boolean,
    default: false,
  },
  showDimensionsSubheader: {
    type: Boolean,
    default: true,
  },
});

const isSpecEB = computed(() => {
  return props.offerTemplate === `${String(store.market).toUpperCase()}_STANDARDA4X2EB`;
});

const checkIfChassisSectionFrameAgreement = computed(() => {
  return props.isFrameAgreement;
});

const checkIfChassisSectionStockVehicle = computed(() => {
  return props.specType === 'stock_vehicle';
});

const checkIfChassisSectionStandard = computed(() => {
  return props.specType !== 'stock_vehicle' && !props.isBev && (!props.isDW5 && !props.isDW5V2);
});

const checkIfChassisSectionStandardBev = computed(() => {
  return props.isBev && (!props.isDW5 && !props.isDW5V2);
});

const checkIfChassisSectionDW5 = computed(() => {
  return props.isDW5 && !props.isBev;
});

const checkIfChassisSectionDW5V2 = computed(() => {
  return props.isDW5V2 && !props.isBev;
});
</script>

<template>
  <ChassisSectionFrameAgreement
    v-if="checkIfChassisSectionFrameAgreement"
    :items="props.items"
    :images="props.images"
    :is-spec-e-b="isSpecEB"
    :show-dimensions-subheader="showDimensionsSubheader"
  />
  <ChassisSectionStockVehicle
    v-else-if="checkIfChassisSectionStockVehicle"
    :items="props.items"
    :images="props.images"
    :is-spec-e-b="isSpecEB"
    :show-dimensions-subheader="showDimensionsSubheader"
  />
  <ChassisSectionStandard
    v-else-if="checkIfChassisSectionStandard"
    :items="props.items"
    :images="props.images"
    :is-spec-e-b="isSpecEB"
    :chassis-description-key="props.chassisDescriptionKey"
    :show-dimensions-subheader="showDimensionsSubheader"
  />
  <ChassisSectionStandardBev
    v-else-if="checkIfChassisSectionStandardBev"
    :items="props.items"
    :images="props.images"
    :is-spec-e-b="isSpecEB"
    :chassis-description-key="props.chassisDescriptionKey"
  />
  <ChassisSectionDW5
    v-else-if="checkIfChassisSectionDW5"
    :items="props.items"
    :images="props.images"
    :is-spec-e-b="isSpecEB"
    :chassis-description-key="props.chassisDescriptionKey"
  />
  <ChassisSectionDW5V2
    v-else-if="checkIfChassisSectionDW5V2"
    :items="props.items"
    :images="props.images"
    :is-spec-e-b="isSpecEB"
    :chassis-description-key="props.chassisDescriptionKey"
    :show-dimensions-subheader="showDimensionsSubheader"
  />
</template>

<style scoped>
</style>
